<template>
  <main>
    <header>
      <div class="box">
        <figure><img src="" alt="" width="100%" height="100%" style="object-fit: cover;"></figure>
        <p><b>{{ userInfo.contact_name }}</b><span>上次登录时间：{{ getLastTime }}</span></p>
        <i>{{ getUserType }}</i>
      </div>
    </header>
    <dl class="order">
      <dt>我的订单</dt>
      <dd @click="goPage('order_list', { status: 80 })">
        <i class="icon-icon--"></i>
        <p>全部订单</p>
      </dd>
      <dd @click="goPage('order_list', { status: 60 })">
        <i class="icon-daizhifu"></i>
        <p>待支付</p>
      </dd>
      <dd @click="goPage('order_list', { status: 61 })">
        <i class="icon-yizhifu"></i>
        <p>已支付</p>
      </dd>
      <dd @click="goPage('order_list', { status: 90 })">
        <i class="icon-jiaoyi"></i>
        <p>已完成</p>
      </dd>
    </dl>
    <ul class="options">
      <router-link tag="li" :to="{ name: 'address' }" class="more"><i class="icon-address_icon"></i><span>地址管理</span></router-link>
      <li class="more"><i class="icon-guanyu"></i><span>关于我们</span></li>
    </ul>
    <button class="quit" @click="signOut">注销登录</button>
    <tabs/>
  </main>
</template>

<script>
import { mapState } from 'vuex';
import moment from '@assets/js/moment';
import Tabs from '@components/tab';
import $user from '@api/user';
export default {
  components: {
    Tabs
  },
  data () {
    return {}
  },
  created () {
  },
  computed: {
    ...mapState(['userInfo']),
    getUserType () {
      const { customerType, isStaff } = this.userInfo;
      const typeObj = {
        '4': 'VIP',
        '16': '企业VIP',
        '2': '分销商',
      };
      if ( isStaff === 1 ) { return '员工'; }
      return typeObj[customerType.toString()] || customerType;
    },
    getLastTime () {
      const { date } = this.userInfo.lastLoginTime;
      return moment(date).fromNow();
    }
  },
  methods: {
    goPage (name, query) {
      this.$router.push({ name, query });
    },
    async signOut () {
      const res = await $user.signOut();
      this.updateUserInfo(null);
      this.$router.push({ name: 'home' });
    }
  }
}
</script>

<style scoped src="./index.css"></style>